import styled from 'styled-components';
import { InsightsSection } from '../TrackingInsights.styles';

/**
 * Measured on the carrier artboard (Figma 20369:198742): the band is `#F2F4F8` (`surface02`),
 * not the `surface01` tint the card sections use, and it is padded 40px above the title and 64px
 * below the last line on desktop — the same asymmetric rhythm as the partner strip.
 */
export const Section = styled(InsightsSection)(({ theme }) => ({
  backgroundColor: theme.colors.surface02,

  [`${theme.mediaBreakpointUp.md}`]: {
    paddingTop: theme.spacing[40],
    paddingBottom: theme.spacing[64],
  },
}));

/** Left-aligned prose under the centred section title, in the same voice as the FAQ block. */
export const Body = styled.div({
  textAlign: 'left',
});
